import Pagination from '@components/Pagination';
import Pillar from '@components/Pillar';
import { SurveyType } from '@data/types';
import useQuestionnaireStore from '@store/questionnaire';
import React, { useEffect } from 'react';
import { hash } from 'utilities/helper';

interface Props extends SurveyType {
  as?: keyof JSX.IntrinsicElements;
}

const Survey: React.FC<Props> = ({ as: Component = 'div', pillars }) => {
  const { questionIndexStore, setPillarsLengthStore } = useQuestionnaireStore();

  // Set the amount of pillars
  useEffect(() => {
    setPillarsLengthStore(pillars.length);
  }, []);

  return (
    <Component className="w-full md:min-h-screen bg-grey overflow-hidden flex flex-col md:flex-row md:-mt-[53px] md:pt-[53px] relative">
      <div className="max-w-outerGrid mx-auto w-full md:min-h-screen -mt-[43px] md:-mt-[53px] h-full flex flex-col order-2 md:order-1">
        <div className="md:mt-[53px] relative flex-1">
          {pillars.map((item, index) => (
            <Pillar {...item} key={hash(item)} pillarIndex={index} />
          ))}
        </div>
      </div>

      <Pagination currentIndex={questionIndexStore} pillars={pillars} />
    </Component>
  );
};

export default Survey;
/* eslint-enable */
